// @ts-ignore
import React from "react";
import { gql, useMutation } from "@apollo/client";
import {
  CreateBankPreferenceMutationMutation,
  CreateBankPreferenceMutationMutationVariables
} from "../../schemaTypes";
import { normalizeErrors } from "../../utils/normalizeErrors";

export const createBankPreferenceMutation = gql`
  mutation CreateBankPreferenceMutation(
    $bankId: String! 
    $accountNo: String!
  ) {
    createBankPreference(
      input: { 
        bankId: $bankId, 
        accountNo: $accountNo 
      }
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export function useCreateBankPreference(onMessage?: (message: string) => void) {
  const [mutate, { client }] = useMutation<
    CreateBankPreferenceMutationMutation,
    CreateBankPreferenceMutationMutationVariables
  >(createBankPreferenceMutation);

  const submit = async (values: CreateBankPreferenceMutationMutationVariables) => {
    const { data } = await mutate({ variables: values });
    const result = data?.createBankPreference;

    // Proper error handling
    if (result?.errors && result.errors.length > 0) {
      // Return normalized error map for form usage
      return normalizeErrors(result.errors);
    }

    if (result?.message && onMessage) {
      onMessage(result.message);
    }

    await client.resetStore();
    return null;
  };

  return { submit };
}